import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import DateUtils from 'src/app/utils/date';
import { formatCurrency, CurrencyPipe } from '@angular/common'
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';

@Component({
  selector: 'app-deal-by-age-amount',
  templateUrl: './deal-by-age-amount.component.html',
  styleUrls: ['./deal-by-age-amount.component.css']
})
export class DealByAgeAmountComponent implements OnInit {
  showTable = false;
  dateUtil = new DateUtils;
  selectedIds = null;
  selectedType = null;
  dateRange = {startDate: null, endDate: null};
  dateType = '90';
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title:  "Deal name", key:  "name" },
      { title:  "Client", key:  "clientName" },
      { title:  "Age (Days)", key:  "age" , transform: (f, rowData) => `${rowData.status === 0 ? f : 'N/A'}`}, 
      { title:  "Amount", key:  "amount", transform: (f, rowData) =>  this.getCurr(f, rowData.currency)},
      { title:  "Forecast Amount", key:  "forecastAmount", transform: (f, rowData) =>  this.getCurr(f, rowData.currency)},
      { title:  "Forecast Date", key:  "forecastDate" , transform:(fieldData) => this.getDate(fieldData)},
      { title:  "Close Date", key:  "actualClosedDate", transform:(fieldData) => this.getDate(fieldData) },
    ], 
    rows: [],
    options: {
      bulkActions: [],
      singleActions: [],
      noOfRowsToDisplay: 3
    }
  }
  getDate(date) {
    return date ? new Date(date).toLocaleDateString() : 'N/A'
  }
  getCurr(f, currency) {
    return f && Number(f) ? new CurrencyPipe('en').transform(f, currency) : 'N/A'
  }
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    ) {
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));

   }

  ngOnInit() {
    this.performRepSrv.selected_users.subscribe(res => {
      if(res && res.type) {        
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
      }
      this.getDeals()
    })
  }
  dateChange({dateRange, dateType}) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.getDeals();
  }
  
  getDeals() {
    this.showTable = false;
    let filter: any = {dateFilter: this.dateRange}
    if(this.selectedType === 'salesperson') {
      filter = {...filter, salesPerson: {ids: this.selectedIds}}
    }
    this.dealSrv.fetchDeals(this.selectedIds, filter).subscribe(res => {
      this.dataTable.rows = res;
      this.dataTable.dataChangedObs.next(true);
      this.showTable = true;
    })
  }

}
